<template>
  <div>
    <b-dropdown aria-role="list" v-model="sort" class="dropdown-list c-w-100">
      <template #trigger="{ active }">
        <b-button
          :icon-right="active ? 'menu-up' : 'menu-down'"
          class="btn-dropdown label-14 pl-0 border-none"
        >
          <div class="is-flex is-align-items-center">
            <img
              src="@/assets/icons/used-sort-rounded.svg"
              alt=""
              class="icon-sort-rounded"
            />
            <p class="averta-regular mr-5">
              {{
                sort ? (sort === "asc" ? "Terlama" : "Terbaru") : "Pilih Urutan"
              }}
            </p>
          </div>
        </b-button>
      </template>
      <b-dropdown-item aria-role="listitem" value="desc" @click="onClickItem"
        >Terbaru</b-dropdown-item
      >
      <b-dropdown-item aria-role="listitem" value="asc" @click="onClickItem"
        >Terlama</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'DropdownSortNewOld',
  data () {
    return {
      sort: null
    }
  },
  methods: {
    onClickItem () {
      this.$emit('clickedItem', true)
    }
  },
  watch: {
    sort () {
      this.$emit('selected', this.sort)
    },
    '$route.query': {
      immediate: true,
      handler (newQuery, oldQuery) {
        if (!oldQuery) {
          if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
            this.sort = newQuery.sort || 'desc'
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.dropdown-list {
  border: 1px solid #e1e1e1;
  border-radius: 5px;
}

.icon-sort-rounded {
  margin-left: 9px;
  margin-right: 7px;
}

.btn-dropdown {
  padding-left: 0 !important;
}
</style>
